
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */

export const title = 'Terms and Conditions';
export const effectiveFromDate = '2020-09-30';
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Section = makeShortcode("Section");
const Heading = makeShortcode("Heading");
const layoutProps = {
  title
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Section id="definitions" mdxType="Section">
      <Heading mdxType="Heading">Definitions</Heading>
      <p>{`We use these basic terms throughout the agreement, and they have specific
meanings. You should know what we mean when we use each of the terms. There's
not going to be a test on it, but it's still useful information.`}</p>
      <ol>
        <li parentName="ol">
          <p parentName="li">{`An `}<q>{`Account`}</q>{` represents your legal relationship with CORE.
An `}<q>{`Associate Account`}</q>{` represents an individual User’s authorization
to log in to and use the Service and serves as a User’s identity on CORE.
“Organizations” are shared workspaces that may be associated with a single
entity or with one or more Associates where multiple Associates can
collaborate across many projects at once. A Associate Account can be a
member of any number of Organizations.`}</p>
        </li>
        <li parentName="ol">
          <p parentName="li">{`The `}<q>{`Agreement`}</q>{` refers, collectively, to all the terms, conditions,
notices contained or referenced in this document (the “Terms and
Conditions” or the "Terms") and all other operating rules, policies
(including the CORE Privacy Statement and Cookies Policy available at
`}<a parentName="p" {...{
              "href": "http://www.jisc.ac.uk/core"
            }}>{`www.jisc.ac.uk/core`}</a>{` (INSERT HYPERLINK) and procedures that we may publish
from time to time on the Website. Most of our site policies are available
at `}<a parentName="p" {...{
              "href": "http://www.jisc.ac.uk/core"
            }}>{`www.jisc.ac.uk/core`}</a>{` (INSERT HYPERLINK).`}</p>
        </li>
        <li parentName="ol">
          <q>Beta Previews</q> mean software, services, or features identified as
alpha, beta, preview, early access, or evaluation, or words or phrases with
similar meanings.
        </li>
        <li parentName="ol">
          <q>Content</q> refers to content featured or displayed through the Website,
including without limitation text, data, articles, images, photographs,
graphics, software, applications, designs, features, and other materials
that are available on the Website or otherwise available through the
Service. "Content" also includes Services. “Associate-Generated Content”
is Content, written or otherwise, created or uploaded by our Associates.
"Your Associate Content" is Content that you create or own.
        </li>
        <li parentName="ol">
          <q>CORE</q>, <q>We</q>, and <q>Us</q> refer to CORE, Inc., as well as our
affiliates, directors, subsidiaries, contractors, licensors, officers, agents,
and employees.
        </li>
        <li parentName="ol">
          <p parentName="li">{`The `}<q>{`Service`}</q>{` refers to the applications, software, products, and
services provided by CORE, including any Beta Previews.`}</p>
        </li>
        <li parentName="ol">
          <q>The User</q>, <q>You</q>, and <q>Your</q> refer to the individual
person, company, or organization that has visited or is using the Website
or Service; that accesses or uses any part of the Account; or that directs
the use of the Account in the performance of its functions. An Associate
Representative must be at least 18 years of age and authorized to bind the
Associate contractually.   Any individual as a User of CORE Services, must
be at least 13 years of age.  Special terms may apply for business or
government Accounts See Section B(5) Additional Terms.
        </li>
        <li parentName="ol">
          <p parentName="li">{`The `}<q>{`Website`}</q>{` refers to CORE’s website located at `}<a parentName="p" {...{
              "href": "http://www.jisc.ac.uk/core"
            }}>{`www.jisc.ac.uk/core`}</a>{`
and all content, services, and products provided by CORE at or through the
Website. Occasionally, websites owned by CORE may provide different or
additional Terms and Conditions. If those additional terms conflict with
this Agreement, the more specific terms apply to the relevant page or
service.`}</p>
        </li>
      </ol>
    </Section>
    <Section id="accounts" mdxType="Section">
      <Heading mdxType="Heading">Account Terms</Heading>
      <Section id="account-controls" mdxType="Section">
        <Heading mdxType="Heading">Account Controls</Heading>
        <p>{`Associates and Associate Representatives. Subject to these Terms, CORE only
recognizes legally incorporated entities as Associates.`}</p>
        <p>{`The information provided shall include, evidence of currently recognized
legally incorporated status with a description of your mission statement.`}</p>
      </Section>
      <Section id="account-required-information" mdxType="Section">
        <Heading mdxType="Heading">Required Information</Heading>
        <p>{`The Associate Representative must provide a valid email address in order to
complete the signup process. Because you are accepting these terms on behalf
of a legal entity we need more information about the legal entity.`}</p>
        <p>{`In consideration of your use of the Service, you represent that you are of
legal age to form a binding contract and are not a person barred from
receiving services under any applicable jurisdiction.`}</p>
        <p>{`You also agree to:`}</p>
        <ol>
          <li parentName="ol">
            <p parentName="li">{`provide true, accurate, current and complete information about yourself
as prompted by the CORE Service's registration form (the `}<q>{`Registration
Data`}</q>{`) and`}</p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`maintain and promptly update the Registration Data to keep it true,
accurate, current and complete. If you provide any information that is
untrue, inaccurate, not current or incomplete, or CORE has reasonable
grounds to suspect that such information is untrue, inaccurate, not
current or incomplete, CORE has the right to suspend or terminate your
account and refuse any and all current or future use of the CORE
Services (or any portion thereof).`}</p>
          </li>
        </ol>
      </Section>
      <Section id="account-requirements" mdxType="Section">
        <Heading mdxType="Heading">Account Requirements</Heading>
        <p>{`We have a few simple rules for Associate Accounts on CORE's Service.`}</p>
        <ol>
          <li parentName="ol">
            <p parentName="li">{`You must be a human to create an Account. Accounts registered by `}<q>{`bots`}</q>{` or other automated methods are not permitted. We do permit machine accounts.`}</p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`One person or legal entity may maintain no more than one free Account.`}</p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`You must be age 13 or older. CORE does not target our Service to children under 13, and we do not permit any Associates under 18 on our Service. If we learn of any User under the age of 13, we will terminate the Users Account immediately.  If you are a resident of a country outside the European Union, your country’s minimum age may be older; in such a case, you are responsible for complying with your country’s laws.`}</p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`A User Your login may only be used by one person — i.e., a single login may not be shared by multiple people.`}</p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`You may not use CORE in violation of export control or sanctions laws of any applicable jurisdiction. CORE may allow persons in certain sanctioned countries or territories to access certain CORE services pursuant to UK government authorizations such as, without limitation, governmental Export Control policy.`}</p>
          </li>
        </ol>
      </Section>
      <Section mdxType="Section">
        <Heading mdxType="Heading">Associate Account Security</Heading>
        <p>{`You are responsible for keeping your Account secure while you use our Service. We offer tools to help you maintain your Account's security, but the content of your Account and its security are up to you.
You are responsible for all Content uploaded and activity that occurs under your Account (even when content is uploaded by others who have Accounts under your Account).
You are responsible for maintaining the security of your Account and password. CORE cannot and will not be liable for any loss or damage from your failure to comply with this security obligation.
You will promptly notify CORE  if you become aware of any unauthorized use of, or access to, our Service through your Account, including any unauthorized use of your password or Account.`}</p>
      </Section>
      <Section mdxType="Section">
        <Heading mdxType="Heading">Additional Terms</Heading>
        <p>{`In some situations, third parties' terms may apply to your use of CORE. For example, you may be a member of an organization which is on CORE with its own terms or license agreements; you may download an application that integrates with CORE; or you may use CORE to authenticate to another service. Please be aware that while these Terms are our full agreement with you, other parties' terms govern their relationships with you.`}</p>
      </Section>
    </Section>
    <Section id="acceptable-use" mdxType="Section">
  <Heading mdxType="Heading">Acceptable Use</Heading>
    </Section>
    <Section id="associates" mdxType="Section">
  <Heading mdxType="Heading">Associate(s)</Heading>
    </Section>
    <Section id="associate-generated-content" mdxType="Section">
  <Heading mdxType="Heading">Associate-Generated Content</Heading>
    </Section>
    <Section id="private-repositories" mdxType="Section">
  <Heading mdxType="Heading">Private Repositories</Heading>
    </Section>
    <Section id="copyrights" mdxType="Section">
  <Heading mdxType="Heading">Copyright & DMCA Policy</Heading>
    </Section>
    <Section id="intellectual-properties" mdxType="Section">
  <Heading mdxType="Heading">Intellectual Property Notice</Heading>
    </Section>
    <Section id="api" mdxType="Section">
  <Heading mdxType="Heading">API Terms (Application Programme Interface)</Heading>
    </Section>
    <Section id="additional" mdxType="Section">
  <Heading mdxType="Heading">Additional Terms for CORE Pages and Learning Lab</Heading>
    </Section>
    <Section id="betas" mdxType="Section">
  <Heading mdxType="Heading">Beta Previews</Heading>
    </Section>
    <Section id="third-party-applications" mdxType="Section">
  <Heading mdxType="Heading">Third Party Applications</Heading>
    </Section>
    <Section id="advertising" mdxType="Section">
  <Heading mdxType="Heading">Advertising on CORE</Heading>
    </Section>
    <Section id="cancellation" mdxType="Section">
  <Heading mdxType="Heading">Cancellation and Termination</Heading>
    </Section>
    <Section id="communications" mdxType="Section">
  <Heading mdxType="Heading">Communications with CORE</Heading>
    </Section>
    <Section id="warranties" mdxType="Section">
  <Heading mdxType="Heading">Disclaimer of Warranties</Heading>
    </Section>
    <Section id="limitation-of-liability" mdxType="Section">
  <Heading mdxType="Heading">Limitation of Liability</Heading>
    </Section>
    <Section id="" mdxType="Section">
  <Heading mdxType="Heading">Release and Indemnification</Heading>
    </Section>
    <Section id="user" mdxType="Section">
  <Heading mdxType="Heading">User(s)</Heading>
    </Section>
    <Section id="website" mdxType="Section">
  <Heading mdxType="Heading">Website</Heading>
    </Section>
    <Section id="changes" mdxType="Section">
  <Heading mdxType="Heading">Changes to these Terms and Conditions</Heading>
    </Section>
    <Section id="misc" mdxType="Section">
  <Heading mdxType="Heading">Miscellaneous</Heading>
    </Section>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;